import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  get_user_all_notifications,
  user_read_notifications,
  user_all_read_notifications,
} from "./notificationActions";


import DataNotFound from "../../images/EmptyData.jpg";
import CustomPagination from "../../components/CustomPagination";
import { useDynamicTranslate } from "../../hooks/useDynamicTranslate";
import { useTranslation } from "react-i18next";

const Notifications = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user, accessToken } = useSelector((state) => state.auth);
  const { batchTranslate } = useDynamicTranslate();
  const { t, i18n } = useTranslation();
  const language = localStorage.getItem("language");
  const { userallNotification, totalnotifications, notificationPayload } =
    useSelector((state) => state.notifications);

  const [page, setPage] = useState(1);
  const [perPage] = useState(10);
  const [loading, setLoading] = useState(true);

  // Fetch notifications when token/page changes
  useEffect(() => {
    if (!accessToken || !user) return;

    const fetchNotifications = async () => {
      setLoading(true);
      await get_user_all_notifications(dispatch, batchTranslate, language, page, perPage);
      setLoading(false);
    };

    fetchNotifications();
  }, [accessToken, page, perPage, dispatch, user, i18n.language]);

  const formatDate = (date) => {
    const now = new Date();
    const d = new Date(date);
    const diff = now - d;
    const minute = 60_000;
    const hour = minute * 60;
    const day = hour * 24;

    if (now.toDateString() === d.toDateString()) {
      if (diff < hour) {
        const m = Math.floor(diff / minute);
        // return m === 0 ? "Just now" : `${m} minute${m > 1 ? "s" : ""} ago`;
        return m === 0 ? t("notifications.justNow") : t("notifications.minutesAgo", { count: m });
      }
      const h = Math.floor(diff / hour);
      // return `${h} hour${h > 1 ? "s" : ""} ago`;
      return t("notifications.hoursAgo", { count: h });
    }
    const days = Math.ceil(diff / day);
    // return `${days} day${days > 1 ? "s" : ""} ago`;
    return t("notifications.daysAgo", { count: days });
  };

  const readOne = async (item) => {
    const success = await user_read_notifications(dispatch, item?.notification_id, 2);

    if (success === true) {
      navigate(`/auction/${item?.item_slug}`);
    }

    // Refresh list
    await get_user_all_notifications(dispatch, batchTranslate, language, page, perPage);
  };

  const readAll = async () => {
    await user_all_read_notifications(dispatch, 1);
    await get_user_all_notifications(dispatch, batchTranslate, language, page, perPage);
  };

  const goToDetail = (item) => {
    navigate(`/auction/${item?.item_slug}`);
  };

  if (!user) return null;

  return (
    <div className="notificationPage container">
      <div className="header">
        <h2>{t("notifications.notificationsTitle")}</h2>
        <div className="notificiation-header-2">
          <p>{t("notifications.notificationsSubTitle")}</p>

          {totalnotifications > 0 && (
            <p className="mark-asread" onClick={readAll}>
              {t("notifications.markAllAsRead")}
            </p>
          )}
        </div>
      </div>

      <div className="allnotification">
        {loading ? (
          <div className="text-center py-5">{t("notifications.loadingNotifications")}</div>
        ) : totalnotifications > 0 ? (
          userallNotification?.map((item, index) => (
            <React.Fragment key={item.notification_id}>
              <div
                className={`notificationcart ${item?.is_seen ? "" : "bg-white"
                  }`}
              // onClick={() =>
              //   item?.is_seen ? goToDetail(item) : readOne(item)
              // }
              >
                <div className="left-side">
                  <div className="details">
                    <div className="notification-badge">
                      {item?.notification_type || "Update"}
                    </div>

                    <h6
                      className={`m-0 ${item?.is_seen
                        ? "notification-seencolor"
                        : "notification-withoutseencolor fw-bold"
                        }`}
                    >
                      {item?.notification_title}
                    </h6>

                    <p className="m-0">{item?.notification_message}</p>
                  </div>
                </div>

                <div className="timer-side">
                  <i className="bi bi-clock"></i>
                  <span>{formatDate(item?.created_at)}</span>
                </div>
              </div>

              <div className="divide"></div>
            </React.Fragment>
          ))
        ) : (
          <div className="NotFoundData text-center py-5">
            <img
              src={DataNotFound}
              alt="No notifications"
              className="w-25 mb-3"
            />
            <p>{t("notifications.noNoitifications")}</p>
          </div>
        )}
      </div>

      {totalnotifications > 0 && !loading && (
        // <CustomPagination
        //   total={totalnotifications}
        //   currentPage={page}
        //   perPage={perPage}
        //   onPageChange={(newPage) => setPage(newPage)}
        // />
        <CustomPagination
          total={totalnotifications}
          onPageChange={(page, perPage) => {
            // get_all_orders(dispatch, statusFilter, page, perPage);
            get_user_all_notifications(dispatch, batchTranslate, language, page, perPage);
          }}
        />
      )}

    </div>
  );
};

export default Notifications;


